module.exports = __webpack_public_path__ + "img/binding_mb_tab_05.e780b8e2.png";